// eslint-disable-next-line import/prefer-default-export
export function initAccordions() {
  const accordions = document.querySelectorAll('.accordion .accordion__btn');
  accordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      accordion.classList.toggle('accordion__btn--active');

      const panel = accordion.nextElementSibling;
      const oldDisplay = panel.style.display;

      panel.style.display = oldDisplay === 'block' ? 'none' : 'block';
    });
  });
}
